




































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import uuid from 'uuid/v4';
import { eventsHub } from '@/main';

@Component({})
export default class IpRangeFieldComponent extends Vue {

  @Inject() public $validator: any;

  @Prop(String) public fromTitle!: string;
  @Prop(String) public toTitle!: string;
  @Prop(String) public inputName!: string;
  @Prop(String) public inputIdProp!: string;
  @Prop(String) public staticInputId!: string;
  @Prop(String) public optionalText!: string;
  @Prop([String, Number]) public dataAttribute!: string | number;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;
  @Prop([Array]) public initialValue!: string[];
  @Prop([String, Number]) public placeholder!: string | number;
  @Prop(Number) public maxLength!: number;
  @Prop(Number) public maxValue!: number;
  @Prop(Number) public minValue!: number;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Boolean) public isDisabled!: boolean;
  @Prop(Boolean) public autofocusProp!: boolean;
  @Prop(Boolean) public searchInput!: boolean;
  @Prop(Boolean) public validateOnInput!: boolean;
  @Prop(Boolean) public validateOnBlur!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;
  @Prop(Boolean) public clearField!: boolean;
  @Prop(Boolean) public ipIsInRange!: boolean;

  private inputModel: string[] = [];
  private maxLengthVal: number = 0;
  private inputId: string = '';
  private htmlName: string = '';
  private startIp = '';
  private endIp = '';

  public created() {
    this.inputId = this.staticInputId || 'input' + uuid();
    this.htmlName = this.inputName || this.$t(this.fromTitle).toString();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
    this.$validator.extend('ipIsInRange',
        {
          getMessage: (field: any) => eventsHub.$t('invalidIpRangeMessage', { field }),
          validate: (ips) => {
            return this.validateIpRange(ips[0], ips[1]);
          },
        });
  }

  public mounted() {
    this.inputModel = this.initialValue ? this.initialValue!.toString().split('-') : [];
    if (this.initialValue) {
      this.startIp = this.initialValue[0];
      this.endIp = this.initialValue[1];
      this.$emit('input', this.inputModel);
    }
    if (this.validateOnInput) {
      const matcher = {
        name: this.inputId,
        scope: this.formName,
      };
      const field: any = this.$validator.fields.find(matcher);
      if (field) {
        field.update({ events: 'input' });
      }
    }
  }

  public startChange(ipLocal, port, validIp) {
    this.startIp = ipLocal;
    this.inputModel[0] = this.startIp;
    this.$emit('input', this.inputModel);
  }

  public endChange(ipLocal, port, validIp) {
    this.endIp = ipLocal;
    this.inputModel[1] = this.endIp;
    this.$emit('input', this.inputModel);
  }

  public updateInputModel($event: any): void {
    if (this.maxLengthVal && $event.target.value.length > this.maxLengthVal) {
      $event.target.value = $event.target.value.slice(0, this.maxLengthVal);
    }
    this.inputModel = $event.target.value;
    this.$emit('input', this.inputModel.length > 0 ? this.inputModel : null);
  }

  public updateNull($event: any): void {
    this.inputModel = [];
    this.$emit('input', []);
  }

  public blurInputModel($event: any): void {
    this.$emit('blur', $event.target.value);
  }

  get inputValue(): string[] {
    if (!this.inputModel) {
      return this.initialValue || [];
    }
    return this.inputModel || [];
  }

  get validators(): any {
    const validator: any = {};
    if (this.isRequired) {
      validator.required = this.isRequired;
    }
    if (this.ipIsInRange) {
      validator.ipIsInRange = this.ipIsInRange;
    }
    return validator;
  }

  public validateIpRange(startIp, endIp) {
    const ipToNum = (ip) => {
      return Number(
          ip.split('.')
              .map(d => ('000' + d).substr(-3))
              .join(''),
      );
    };

    const isRangeValid = (rangeStart, rangeEnd) => {
      const rs = ipToNum(rangeStart);
      const re = ipToNum(rangeEnd);
      return ((!rs && !re) || (rs && re) && rs <= re);
    };

    return isRangeValid(startIp, endIp);
  }
}
